import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import header_vector from "../../assets/imgs/secretariats/header_vector.png";
import { getSecretariatsAPI } from "../../services/api";
import ErrorMessage from "../ui_elements/ErrorMessage";
import defaultPhoto from "../../assets/imgs/default_photo.svg";

const MunicipalSecretariats = () => {
  const [secretariats, setSecretariats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getSecretariatsAPI();
        setSecretariats(response.data);
      } catch (err) {
        console.error("Erro ao carregar os dados das secretarias:", err);
        setError("Não foi possível carregar as secretarias.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div className="py-8 text-center text-gray-500">Carregando secretarias...</div>;
  if (error) return (
    <ErrorMessage
      title="Secretarias temporariamente indisponíveis"
      description="Não foi possível carregar as informações das Secretarias Municipais. Nossa equipe já está trabalhando para restabelecer o acesso o mais breve possível."
    />
  );

  return (
    <div className="py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center mb-8">
          <p className="text-gray-700 text-justify text-lg md:text-2xl leading-relaxed md:ml-6">
            "A Secretaria Municipal de Governo tem por finalidade planejar,
            organizar, dirigir, coordenar e controlar as ações políticas e de
            comunicação social do Poder Executivo Municipal."
          </p>
          <img
            src={header_vector}
            alt="Header Vector"
            className="w-full md:w-2/4 mb-4 md:mb-0"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-20">
          {secretariats.map((secretariat) => (
            <div
              key={secretariat.id}
              className="bg-gray-100 rounded-2xl shadow-lg text-center flex flex-col"
            >
              <div className="flex-1 p-4">
                <img
                  src={secretariat.photo || defaultPhoto}
                  alt={secretariat.name}
                  className="w-30 h-30 mx-auto"
                  onError={(e) => { e.target.src = defaultPhoto; e.target.onerror = null; }}
                />
                <h3 className="text-lg font-semibold text-gray-800 mt-2">
                  {secretariat.name}
                </h3>
                <p className="text-sm text-gray-600">
                  {secretariat.responsible}
                </p>
              </div>
              <div className="p-4 pt-0">
                <button
                  onClick={() => navigate(`/secretarias/${secretariat.id}`)}
                  className="w-full bg-blue-600 text-white text-sm font-semibold px-4 py-2 rounded-md hover:bg-blue-700"
                >
                  Mais informações
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MunicipalSecretariats;
